import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Users, Star, MapPin, BookOpen } from "lucide-react";

interface Stats {
  coaches: number;
  experiences: number;
  cities: number;
  rating: string;
}

export const LivePlatformStats = () => {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const db = supabase as any;

        const coachesRes = await db
          .from("coach_profiles")
          .select("id", { count: "exact", head: true })
          .eq("is_active", true);

        const experiencesRes = await db
          .from("experiences")
          .select("id", { count: "exact", head: true })
          .eq("is_active", true);

        const citiesRes = await db
          .from("coach_profiles")
          .select("location_text")
          .eq("is_active", true)
          .not("location_text", "is", null);

        const uniqueCities = new Set(
          ((citiesRes.data as any[]) || [])
            .map((c: any) => c.location_text?.split(",").pop()?.trim())
            .filter(Boolean)
        );

        setStats({
          coaches: coachesRes.count || 0,
          experiences: experiencesRes.count || 0,
          cities: Math.max(uniqueCities.size, 1),
          rating: "4.9",
        });
      } catch (err) {
        console.error("Failed to fetch platform stats", err);
      }
    };
    fetchStats();
  }, []);

  if (!stats) return null;

  const items = [
    { icon: Users, value: `${stats.coaches}+`, label: "Coaches" },
    { icon: BookOpen, value: `${stats.experiences}+`, label: "Experiences" },
    { icon: MapPin, value: `${stats.cities}`, label: "Cities" },
    { icon: Star, value: stats.rating, label: "Avg Rating" },
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10 py-4">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-2 text-center">
          <item.icon className="h-4 w-4 text-primary/60" />
          <span className="text-lg font-bold text-foreground">{item.value}</span>
          <span className="text-xs text-muted-foreground">{item.label}</span>
        </div>
      ))}
    </div>
  );
};
